import type { HttpPort } from "~/lib/http";

export interface StudentProposal {
  id: string;
  title: string;
  description?: string | null;
  status: "pending" | "approved" | "rejected" | string;
  rejection_reason?: string | null;
  created_at: string;
}

const trim = (value: string) => value.trim();

export function createStudentProposalsModule(http: HttpPort, token: string) {
  return {
    async load(classId: string): Promise<StudentProposal[]> {
      const value = await http.request<{ proposals?: StudentProposal[] }>({ path: `/goals/${classId}/my-proposals`, token });
      return value.proposals ?? [];
    },
    async propose(classId: string, input: { title: string; description?: string }): Promise<void> {
      const title = trim(input.title);
      const description = trim(input.description ?? "");
      if (!title) throw new Error("Bitte gib einen Titel ein.");
      if (title.length > 100) throw new Error("Titel ist zu lang (max. 100 Zeichen).");
      if (description.length > 300) throw new Error("Beschreibung ist zu lang (max. 300 Zeichen).");
      await http.request({ path: `/goals/${classId}/propose`, method: "POST", token, body: { title, ...(description ? { description } : {}) } });
    }
  };
}

export type StudentProposalsModule = ReturnType<typeof createStudentProposalsModule>;
